import { render } from "./SelecionarColaborador.vue?vue&type=template&id=25d75656&scoped=true&ts=true"
import script from "./SelecionarColaborador.vue?vue&type=script&lang=ts"
export * from "./SelecionarColaborador.vue?vue&type=script&lang=ts"

import "./SelecionarColaborador.vue?vue&type=style&index=0&id=25d75656&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d75656"]])

export default __exports__